/**
 * Phone codes offered in the member phone-code dropdown.
 *
 * The API (GET /countries-for-dropdown) returns every row of minty_countries,
 * so the dropdown has to be narrowed here. The order below is intentional and
 * must be preserved: Singapore, China, Hong Kong, then the remaining South East
 * Asian countries with Taiwan closing that block, followed by the non-Asian
 * countries in the order they were requested.
 */
export const PHONE_CODES_ALLOWED = [
  '65',  // Singapore
  '86',  // China
  '852', // Hong Kong
  '60',  // Malaysia
  '66',  // Thailand
  '84',  // Viet Nam
  '673', // Brunei Darussalam
  '855', // Cambodia
  '62',  // Indonesia
  '856', // Laos
  '95',  // Myanmar
  '63',  // Philippines
  '670', // Timor-Leste
  '886', // Taiwan
  '61',  // Australia
  '64',  // New Zealand
  '49',  // Germany
  '34',  // Spain
  '31',  // Netherlands
  '33',  // France
  '44',  // United Kingdom
  '39',  // Italy
  '1',   // Canada and the United States share this code, so it appears once
  '351', // Portugal
  '55',  // Brazil
  '91',  // India
]

/**
 * Narrow the API country list down to PHONE_CODES_ALLOWED, in that exact order.
 * Duplicate rows are dropped too - minty_countries holds Singapore and Viet Nam
 * twice, which made +65 and +84 appear twice in the dropdown.
 *
 * keepCode: the code currently stored on the member. A member saved with a code
 * outside the list (e.g. +81) keeps it selectable, appended at the end, so that
 * opening Profile never silently changes their phone code.
 */
export const filterPhoneCodes = (countryData, keepCode = '') => {
  const list = Array.isArray(countryData) ? countryData : [];
  const options = [];

  PHONE_CODES_ALLOWED.forEach((code) => {
    const found = list.find((item) => String(item.value) === code);
    if (found) {
      options.push(found);
    }
  });

  const kept = String(keepCode ?? '');
  if (kept !== '' && !PHONE_CODES_ALLOWED.includes(kept)) {
    const found = list.find((item) => String(item.value) === kept);
    if (found) {
      options.push(found);
    }
  }

  return options;
}
